export type AppPlan = 'free' | 'pro' | 'coach';

export function normalizePlan(value: unknown): AppPlan {
  if (value === 'coach') return 'coach';
  if (value === 'pro') return 'pro';
  return 'free';
}

export function hasProAccess(value: unknown): boolean {
  const plan = normalizePlan(value);
  return plan === 'pro' || plan === 'coach';
}

export function hasCoachAccess(value: unknown): boolean {
  return normalizePlan(value) === 'coach';
}

export function hasWorkoutManagerAccess(
  plan: unknown,
  legacyUnlocked?: boolean | null
): boolean {
  return hasCoachAccess(plan) || legacyUnlocked === true;
}

export function getPlannerWeeklyLimit(plan: unknown): number | null {
  return normalizePlan(plan) === 'free' ? 1 : null;
}
